const module = { name: 'theater/details/shared/calendar', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context } = Fandango_context;


import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from 'require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { global_consts as global_consts_QueryParams } from 'require-core';

const { QueryParams } = global_consts_QueryParams;


import { default as datePicker } from 'swug-fdRequire-call:movie/shared/datePicker';



import { Fandango_eventQueue as eventQueue } from 'require-global';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as historyStates } from 'swug-fdRequire-call:movie/shared/historyStates';



import { default as loadCalendar } from 'swug-fdRequire-call:theater/details/shared/tdp.loadCalendar';



const DataAttribs = {
    DATE: 'data-show-time-date'
}


const RegExes = {
    LAST_HYPHEN: /^(.+)-([^-]+)$/,
}


const Selectors = {
    CONTAINER: 'lazyload-movie-date-picker',
    DATE_PICKER: 'date-picker',
    CAROUSEL: 'date-carousel',
    DATE_LINK: `[${DataAttribs.DATE}]`,
}


const { isDesktop, theaterID } = readPageContext(context)


let selectedDate
function readPageContext(context) {
    const [, , theaterID] = context.req.params.slug.match(RegExes.LAST_HYPHEN);
    return { isDesktop: !context.device.isMobile, theaterID };
}
function onDateClick(e) {
    const dateLink = e.target.closest(Selectors.DATE_LINK);
    if (!dateLink) {
        return;
    }
    const showTimeDate = dateLink.dataset.showTimeDate;
    historyStates.push(historyStates.HistoryEventTypes.CALENDAR, showTimeDate);
    loadCalendar.init();
    if (showTimeDate) {
        track({
            event: EventTypes.DATE_SELECTED,
            dateSelected: showTimeDate
        });
    }
}
function fixConsecutiveGaps(calendar) {
    if (calendar.length < 2) {
        return;
    }
    let priorValue = calendar[calendar.length - 1].hasShowtime;
    for (let i = calendar.length - 2; i > -1; i--) {
        if (!calendar[i].hasShowtime && !priorValue) {
            calendar.splice(i, 1);
        }
        else {
            priorValue = calendar[i].hasShowtime;
        }
    }
}
function onFetchDone(data, cb) {
    if (!data || !Array.isArray(data.calendar) || data.isEmpty) {
        return onFetchFail(null, cb);
    }
    if (selectedDate) {
        data.selectedDate = selectedDate;
    }
    else if (data.selectedDate) {
        selectedDate = data.selectedDate;
    }
    fixConsecutiveGaps(data.calendar);
    const template = isDesktop ? '_dateCarousel' : '_datePicker';
    const markup = swig.render(template, {
        data: {
            movieCalendar: data,
            selectedDate
        }
    });
    const container = document.getElementById(Selectors.CONTAINER);
    container.innerHTML = markup;
    if (isDesktop) {
        const startIndex = data?.calendar.findIndex(date => date.full === selectedDate);
        fdCarousel.init(Selectors.CAROUSEL, {
            autoWidth: true,
            padding: { left: 0, right: 0 },
            gap: 8,
            start: startIndex || 0
        });
    }
    container.addEventListener('click', onDateClick);
    datePicker.highlightDate(isDesktop ? Selectors.CONTAINER : Selectors.DATE_PICKER, selectedDate);
    datePicker.markToday(Selectors.CONTAINER);
    eventQueue.emit(eventQueue.EventNames.AB_TEST_4476_READY);
    cb(null, Object.assign(data, {
        selectedDate
    }));
}
function onFetchFail(data, cb) {
    const container = document.getElementById(Selectors.CONTAINER);
    container.innerHTML = '<div class="fd-panel dark__bordered__section">Unable to complete loading the calendar.</div>';
    cb(true, null);
}
function load(cb) {
    selectedDate = dateFromQuery(QueryParams.DATE) || dateFromQuery(QueryParams.START_DATE) || null;
    const params = {};
    if (selectedDate) {
        params[QueryParams.START_DATE] = selectedDate;
    }
    const url = links.napiTheaterCalendar({
        id: theaterID,
    }, params);
    xhr.ajax({
        url,
        method: 'GET',
        timeout: 15000,
    })
        .done(data => onFetchDone(data, cb))
        .fail(err => onFetchFail(err, cb));
}
module.exports = {
    load
};
export default module.exports;